export default {"src":"/_next/static/media/next.8380ea8a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};